import OneSignal from 'react-onesignal';

export default async function runOneSignal() {
    await OneSignal.init({ appId: '87aac1d1-b418-4005-a42b-76b1a744436c', allowLocalhostAsSecureOrigin: true });

    await OneSignal.showSlidedownPrompt()
    console.log("OneSignal Slidedown Prompt Shown");
}
